module.exports = require("regenerator-runtime");



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/~/babel-runtime/regenerator/index.js
 ** module id = 114
 ** module chunks = 0
 **/